import React, {useState, useEffect} from "react";
import {Row, Col} from "react-flexbox-grid";
import {Button, Modal, Form, Container} from "react-bootstrap";
import {css} from "glamor";
import {Tab, Tabs} from "react-bootstrap";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import DataContext from "./mapanalysis/cxContext";
import {SelectCountyChart} from "./mapanalysis/seCountiesChart";
import {PopulationDitsChart} from "./mapanalysis/crops/popDistribution";
import {AgriActivitiesChart} from "./mapanalysis/crops/agriActivties";
import {DiverseEconomicActivitiesChart} from "./mapanalysis/diverseEconActivities";
import {EconomicStrengthIndexChart} from "./mapanalysis/econStatusIndex";
import {ProdDistChannel} from "./mapanalysis/distPdChannels";
import {WeatherChart} from "./mapanalysis/weatherChart";
import {AnnualPrecipitationChart} from "./mapanalysis/anualPrepChart";
import {AnnualTempChart} from "./mapanalysis/anualTempChart";
import {TopoRowChart} from "./mapanalysis/topoRowChart";
import {LandAreaHa} from "./mapanalysis/crops/landArea";
import {SoilFertilityChart} from "./mapanalysis/ButtonCharts/soilFertility";
import {ChoroplethmapChart} from "./mapanalysis/choroplethmap";
import {NoofHouseHoldPractisingFarming} from "./mapanalysis/crops/housePropotions";
import {CRoadDensityChart} from "./mapanalysis/ButtonCharts/cRoadDensity";
import {NumberOfMarketsCrops} from "./mapanalysis/ButtonCharts/cNumber0fMarkets";
import {NumberOfAgroDealersCrops} from "./mapanalysis/ButtonCharts/cNumberOfAgroDealers";
import {NumberOfRetailersCrops} from "./mapanalysis/ButtonCharts/cNumberOfRetailers";
import {TravelTimeCrop} from "./mapanalysis/ButtonCharts/cTravelTimeToMarket";
import Agriculture from "./TabContents/agriculture";
import Loader from "react-loader-spinner";

/* Mapping and analysis page*/
/* divided into two  tabs 
 - Indicators and Agriculture
 - Indicator tab renders biosphysical and economic conditions 
 at  a national level.
 */
export const Mapping = (props) => {
    // toggel  modal dialog box
        /* jsx styles */
    const style = css({
        padding: "0.2rem",
        marginTop: "1.5rem",
        fontSize: "0.9rem",
        "li.nav-item": {
            marginRight: "1rem"
        }
    });

    const chart_widget_style = css({
        background: "white",
        // border: "3px solid aliceblue",
    });
    const text_icons_css = css({
        textAlign: "center",
        boxShadow: " 0 1px 2px rgba(0,0,0,0.07), 0 2px 4px rgba(0,0,0,0.07), 0 4px 8px rgba(0,0,0,0.07),0 8px 16px rgba(0,0,0,0.07),0 16px 32px rgba(0,0,0,0.07),0 32px 64px rgba(0,0,0,0.07);",

        width: "6.5rem",
        "& btn": {
            padding: "0px !important"
        }
    });
    const section_transition = css({
        textAlign: "center",
        fontSize: "0.9rem",
        color: "#757677",
        fontDisplay: "auto"
    });
    const section_div = css({width: "100%"});

    
    const select_request_data = css({marginLeft: "2rem"});
    const table_style = css({
        overflowY: "scroll",
        maxHeight: "70vh",
        width: "100%",
        height: "5rem",

        "& tr": {
            "&:hover": {
                background: "#dddd"
            }
        },
        "& td": {
            // padding:rhythm(0.1),
            textAlign: "left",
            borderTop: "1px solid #ddd",
            borderLeft: "1px solid #ddd",
            borderRight: "1px solid #ddd",
            paddingLeft: "5px",
            paddingRight: "5px",
            fontSize: "0.8rem !important",
            color: "#0152aa"
        }
    });
    const crop_economics = css({
        height:"15rem",
        border: "1px solid grey",
        "& g g.axis.y ": {
            display: "none"
        },
        "& svg": {
            height: "14rem"
        }
    });

    const crop_productivity = css({
        "& g g.axis.y ": {
            display: "none"
        }
    });
    const crop_suitability = css({
        "& svg": {
            height: "14rem",
            with: "14rem",
            margin: "auto"
        }
    });

    const tabs_main = css({
        "& ul": {
            marginTop: "1rem"
        },
        "& li button": {
            fontSize: "1.1rem !important",
            padding: "8px 25px 10px !important",
            margin: "5px",
            boxShadow: "box-shadow: 0 0 7px rgba(0, 0, 0, 0.1) inset;",
            overflow: "hiden",
            zIndex: 1,
            borderTop:"3px solid #0670bc"
        }
    })
    const borders = css({
        borderLeft: "1px dashed #91aec6",
        borderRight: "1px dashed #91aec6"
    })
    const climatic_conditions = css({
        borderLeft: "border-left: 1px dashed #91aec6",
        marginLeft:"0.5rem"
    })

    const text_chart_buttons = css({
        margin:"auto"
    })
    return (<>
        <div class="container-fluid">
            <div class="row">
                <div className="col-md-12">
                    <div className="row" style={{display:"block",marginTop:"0.6rem"}}>
                            <Tabs defaultActiveKey="home" id="main" className="mb-3"
                                style={{marginRight: "1rem"}} {...tabs_main}>
                            <Tab eventKey="home" title="Indicators">
                                <div className="preloader">
                                    <div style={{ display: "inline-block" }}>
                                        <Loader
                                            type="Circles"
                                            color="#01528c"
                                            height={120}
                                            width={120}
                                        />
                                        <strong style={{ paddingTop: "15px" }}>
                                            Loading data please wait...
                                                    </strong>
                                    </div>
                                </div> 
                                  <DataContext>
                                    <Row>
                                        <Col md={12}>
                                            <Row style={{width: "90vw"}}>
                                                <div className="col-md-4">
                                                    <div className="row-cols-2">
                                                       <SelectCountyChart/>
                                                    </div>
                                                    <Row style={{float:"left"}}>
                                                        <Col md={12}>
                                                            <ChoroplethmapChart />
                                                        </Col>
                                                    </Row>
                                                </div>
                                               
                                                <div className="col-md-8">
                                                    {/* first row : Biosphysical Indicators*/}
                                                    <Row >
                                                        <div {...section_div}>
                                                            <hr style={{ borderTop:"1px solid 1px solid #e9ecef",marginBottom: "0px",}}/>
                                                            <div className="transition"><div {...section_transition}> Biophysical Indicators</div>
                                                            </div>
                                                      </div>
                                                    </Row>

                                                    <Row style={{marginTop:"0.7rem"}}>
                                                        <Col md={8} {...borders }>
                                                            <Row><h6 style={{ textDecoration: "underline", margin: "auto" }}>Climate Conditions</h6>
                                                            </Row>    
                                                            <Row>
                                                                <Col md={3} style={{marginLeft:"0px"}}>
                                                                    <Row {...text_chart_buttons}>
                                                                        <div style={{ marginTop: "1rem" }}>
                                                                            <h6 style={{ textDecoration: "underline",paddingLeft:"5px" }}>Annual Rainfall (mm)</h6>
                                                                            <Button variant="light" {...text_icons_css}><AnnualPrecipitationChart /></Button>
                                                                        </div>
                                                                    </Row>
                                                                    <Row {...text_chart_buttons}>
                                                                        <div><h6 style={{ textDecoration: "underline", textAlign: "center", paddingLeft: "5px" }}>Annual Temperature(°C)</h6>
                                                                            <Button variant="light" {...text_icons_css}><AnnualTempChart /></Button>
                                                                        </div>
                                                                    </Row>
                                                                </Col>
                                                                <Col md={9}><Row> <div><WeatherChart /></div></Row>                                                     </Col>
                                                            </Row>   
                                                        </Col>
                                                        <Col md={4} {...borders}>
                                                            <Row>
                                                                <div style={{ textAlign: "center", width: "100%", textDecoration: "underline", }}>
                                                                    <h6>Topographical Conditions</h6>
                                                                </div>
                                                        </Row>
                                                        <Row>
                                                            <Col md={12}>
                                                              <div style={{ textAlign: "center",display:"flex",justifyContent:"center" }}>
                                                                <h6 style={{marginTop:"1rem"}}>Soil fertility</h6>
                                                                <Button variant="light" {...text_icons_css}>
                                                                  <SoilFertilityChart />
                                                                </Button>
                                                              </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={12}>
                                                              <TopoRowChart />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                  </Row>
                                                  <Row>
                                                    <Col md={12}>
                                                      <div>
                                                        <hr  style={{  borderTop: 1 + "px" + "solid" + "#808080", marginBottom: "0px",}}/>
                                                        <div className="transition"  style={{  width: 23 + "%", margin: 0 + "auto", marginTop: "-0.75rem", backgroundColor: "white",}}>
                                                          <div {...section_transition}>Themes</div>
                                                        </div>
                                                      </div>
                                                    </Col>
                                                  </Row>

                                                  {/* Economic indicators */}
                                                    <Row {...chart_widget_style}>
                                                        <Tabs defaultActiveKey="profile" id="main" className="mb-3" style={{ marginRight: "1rem" }}>
                                                            <Tab eventKey="profile" title="Demography">
                                                                <Row>
                                                                    <div style={{ display: "flex" }}>
                                                                        <Col {...crop_economics} md={4} style={{ marginRight: "1rem", border: "1px solid grey", marginLeft: "1.5rem", }}>
                                                                            <PopulationDitsChart />
                                                                        </Col>
                                                                        <Col md={8}>
                                                                            <div style={{ textAlign: "center", marginRight: "3rem", border: "1px solid grey", }}>
                                                                                <Row>
                                                                                    <Col md={12}>
                                                                                        <h6 style={{ textDecoration: "underline" }}>
                                                                                            Proportion and Number of Households Practising Farming
                                                                                        </h6>
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row style={{ height: "13rem" }}>
                                                                                    <Col md={6} {...crop_economics} style={{ border: "none" }}>
                                                                                        <AgriActivitiesChart />
                                                                                    </Col>
                                                                                    <Col md={6} {...crop_economics} style={{ border: "none" }}>
                                                                                        <NoofHouseHoldPractisingFarming />
                                                                                    </Col>
                                                                                </Row>
                                                                            </div>
                                                                        </Col>
                                                                    </div>
                                                                </Row>
                                                            </Tab>
                                                            <Tab eventKey="contact" title="Socio-Economic">
                                                                <Row style={{ height: "16rem", margin: "0.1rem", padding: "10px" }}>
                                                                    <Col md={4} {...crop_economics}>
                                                                        <DiverseEconomicActivitiesChart />
                                                                    </Col>
                                                                    <Col md={4} {...crop_economics}>
                                                                        <EconomicStrengthIndexChart />
                                                                    </Col>
                                                                    <Col md={4} {...crop_economics}>
                                                                        <LandAreaHa  {...crop_economics} />
                                                                    </Col>
                                                                </Row>
                                                            </Tab>
                                                            <Tab  eventKey="socio"     title="Infrastructure">
                                                                <Row style={{ marginLeft: "1rem" }}>
                                                                    <Col md={4} style={{    border: "1px solid grey",   marginRight: "0.5rem",padding:"1.5rem"}}>
                                                                        <div
                                                                            style={{   textAlign: "center",}}>
                                                                            <h6 style={{ textDecoration: "underline" }}>
                                                                                Road infrastructure
                                                                            </h6>
                                                                            <Row>
                                                                                <div>
                                                                                    <h6   style={{ textDecoration: "underline", marginRight: "0.5rem"  }} >
                                                                                        {" "}
                                                                                        Time taken to reach nearest market(Mins)
                                                                                    </h6>
                                                                                    <br />
                                                                                    <div class="oval" style={{ padding: "10px" }}>
                                                                                        <div  style={{textAlign: "center",  margin: "auto",}}   >
                                                                                            <TravelTimeCrop />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div style={{ margin: "auto", }} >
                                                                                    <h6 style={{ textDecoration: "underline",}} >
                                                                                        Road Density
                                                                                    </h6>
                                                                                    <br />
                                                                                    <div class="oval" style={{ padding: "10px" }}>
                                                                                        <div style={{textAlign: "center", margin: "auto",}} >

                                                                                            <CRoadDensityChart />

                                                                                        </div>

                                                                                    </div>

                                                                                </div>

                                                                            </Row>

                                                                        </div>

                                                                    </Col>

                                                                    {/* <Col md={1}></Col> */}

                                                                    <Col md={7} style={{ border: "1px solid grey" }}>
                                                                        <div style={{ textAlign: "center" }}>
                                                                            <Row>
                                                                                <Col md={12}>
                                                                                    <h6 style={{ textDecoration: "underline" }}>
                                                                                        Production and Distribution Channels
                                                                                    </h6>
                                                                                </Col>
                                                                            </Row>
                                                                            <Row>
                                                                                <Col md={6}>
                                                                                    <ProdDistChannel />
                                                                                </Col>
                                                                                <Col md={6}>
                                                                                    <Row>
                                                                                        <div style={{ marginLeft: "5rem" }}>
                                                                                            <h6 style={{ textDecoration: "underline" }}>
                                                                                               {" "}
                                                                                                Number of Markets
                                                                                            </h6>
                                                                                            <br />
                                                                                            <Button variant="light"    {...text_icons_css} style={{ marginTop: "-1.5rem" }}> <strong>
                                                                                                {" "}
                                                                                                <NumberOfMarketsCrops />
                                                                                            </strong>
                                                                                            </Button>
                                                                                        </div>

                                                                                    </Row>

                                                                                    <Row>

                                                                                        <div style={{ marginLeft: "4.7rem" }}>

                                                                                            <h6 style={{ textDecoration: "underline" }}>

                                                                                                {" "}

                                                                                                Number of Agro dealers

                                                                                            </h6>

                                                                                            <br />

                                                                                            <Button

                                                                                                variant="light"

                                                                                                {...text_icons_css}

                                                                                                style={{ marginTop: "-1.5rem" }}

                                                                                            >

                                                                                                <NumberOfAgroDealersCrops />

                                                                                            </Button>

                                                                                        </div>

                                                                                    </Row>

                                                                                    <Row>

                                                                                        <div style={{ marginLeft: "4.5rem" }}>

                                                                                            <h6 style={{ textDecoration: "underline" }}>

                                                                                                Number of Formal Retailers

                                                                                            </h6>

                                                                                            <br />

                                                                                            <Button    variant="light"     {...text_icons_css} style={{ marginTop: "-1.5rem" }}>


                                                                                                <NumberOfRetailersCrops />

                                                                                            </Button>

                                                                                        </div>

                                                                                    </Row>

                                                                                </Col>

                                                                            </Row>

                                                                        </div>

                                                                    </Col>

                                                                </Row>

                                                            </Tab>

                                                            <br />

                                                        </Tabs>


                                                    </Row>

                                       
                                                </div>

                                            </Row>

                                        </Col>

                                    </Row>

                                </DataContext>

                            </Tab>

                            <Tab eventKey="profile" title="Sector">

                                <Row style={{ display: "block" }}>
                                    
                                    <div className="indicator-menus">

                                        <Agriculture />
                                        
                                    </div>

                                </Row>

                            </Tab>

                            <br />

                        </Tabs>

                    </div>

                </div>

            </div>

           
        </div>

    </>)
};
